import * as THREE from "three";
import { useEffect, useCallback, useRef, useState } from "react";
import {useSitePropertiesStore} from "../../store/useGeometryPropertiesStore.js"
import { useMapStore } from "../../store/useMapStore.js";
import { useBoundingBoxStore } from "../../store/useBoundingBoxStore.js";
import { wgs84ToWebMercator } from "../../services/CoordinateTransformService.js";
import fetchRiskAreaData from "./RiskAreaqueries.js";
import PolygonPlane from "./SiteGeometry.jsx";
import { useBPlanPropertiesStore } from "../../store/useGeometryPropertiesStore.js";
import { useLayerStore } from "../../store/useLayerStore.js";
import fetchBPlanData from "./BPlanqueries.js";
import { useGeometryTypeStore } from "../../store/useGeometryPropertiesStore.js";
import { CacheGeometry,LoadFromCache, GetCacheKey, ClearCache } from "../../utils/GeometryHelper.js";
import { GeometryType } from "../../constants/progress.js";


export default function BPLanGeometry() 
{
  const geometryType = GeometryType.BPLAN;
  const scalingFactor = useMapStore(state => state.scalingFactor);
  const [bPlanEntities, setBPlanEntities] = useState([]);  
  const visibleLayers = useLayerStore((state) => state.visibleLayers);
  const updateBPlanPropertyStore = useBPlanPropertiesStore((state)=> state.updateBPlanProperties)
  const {setGeometryType} = useGeometryTypeStore();
  const [crs, setCrs] = useState("EPSG3857"); 
  const boundingBoxNE = useBoundingBoxStore(state => state.ne);
  const boundingBoxSW = useBoundingBoxStore(state => state.sw);
  const metersPerPixel = useMapStore(state => state.metersPerPixel);
  const [selectedEntityId, setSelectedEntityId] = useState(null);
  const CACHE_KEY = "cacheBPlan";
  const CACHE_VERSION = "version_1";
  const cacheKey = GetCacheKey(boundingBoxNE,boundingBoxSW,crs, CACHE_KEY,CACHE_VERSION)
      const fetchData = async () => {
      if(visibleLayers.bauleitplane)
      {
        try {
         let data = LoadFromCache (cacheKey, CACHE_VERSION, 1000 * 60 * 60 * 24) 
         if(!data)
         {
            data = await fetchBPlanData(
            boundingBoxNE.lng,
            boundingBoxNE.lat,
            boundingBoxSW.lng,
            boundingBoxSW.lat
          );
          if (data) {
            setBPlanEntities(data);
            console.log("Number of B Plan entities recieved",data);
            ClearCache(CACHE_KEY);
            CacheGeometry(boundingBoxNE,boundingBoxSW,crs, CACHE_KEY, CACHE_VERSION, data)
          }
        }
        else{
          setBPlanEntities(data);

        }
        
      } catch (error) {
        console.error('Failed to fetch data:', error);
        // Handle error (show notification, etc.)
      }

      }
      
    };
 
  const handleEntitySelect = (entity) => 
    {
      console.log("Entity Name",entity.Name)
      setSelectedEntityId(entity.id);
      setGeometryType(entity.Name);
      updateBPlanPropertyStore(
        entity.objectId, 
        entity.type,
        entity.url,
        entity.label, 
        entity.kommune,
        entity.nutzungsart,
        entity.wirksamkeit,
        entity.datum,
        entity.status,

      )
  //     if (entity.url) {
  //   window.open(entity.url, "_blank", "noopener,noreferrer");
  // }
     
    };
  const handleBackgroundClick = () => 
    {
      setSelectedEntityId(null);
    };
    useEffect(() => 
    {
      //console.log("Fetching BPlan")
      fetchData();
     // console.log(bbArray)
      
   }, [visibleLayers.bauleitplane]);

  return (
    <>
      <group>
      {bPlanEntities.length > 0 && (
      <PolygonPlane 
        entities={bPlanEntities}
        selectedEntityId={selectedEntityId}
        setSelectedEntityId={setSelectedEntityId}
        inputColor ={"#c4afa6"}
        inputVisibilty={visibleLayers.bauleitplane}
        onEntitySelect={handleEntitySelect}
        className={"BPlanEntity"}
        crs={"EPSG3857"}
        geometryType={geometryType}
        zTransform = {[0,3,0]}
      />
    )}
    </group>
    </>
  );
}